'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.productInfoBoxComponent = undefined;

var _marked = require('marked');

var _marked2 = _interopRequireDefault(_marked);

var _markedRenderer = require('./../../../common/core/markedRenderer');

var _markedRenderer2 = _interopRequireDefault(_markedRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_marked2.default.setOptions({
    renderer: _markedRenderer2.default,
    breaks: false,
    sanitize: true
});

var productInfoBoxComponent = exports.productInfoBoxComponent = {
    template: require('./product-info-box.html'),
    bindings: {
        title: '@',
        text: '<'
    },
    controllerAs: 'vm',
    controller: function controller() {
        'ngInject';

        var vm = this;
        vm.$onInit = init;

        function init() {
            if (vm.text) {
                vm.text = (0, _marked2.default)(vm.text || '');
            }
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./features/product/components/product-info-box.js
// module id = 973
// module chunks = 0